import { render, staticRenderFns } from "./AddStartupsCustomField.vue?vue&type=template&id=b4724592&scoped=true&"
import script from "./AddStartupsCustomField.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddStartupsCustomField.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AddStartupsCustomField.vue?vue&type=style&index=0&id=b4724592&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4724592",
  null
  
)

export default component.exports